import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { SESSIONS_DESIGNER_ENABLED } from '../../utils/features';
import SessionsDesignerLockedPage from '../../pages/SessionsDesignerLockedPage';

export default function SessionsDesignerGate({ children }) {
  const { isLoggedIn, isCoach } = useUser();
  if (!isLoggedIn || !isCoach) return <Navigate to="/" replace />;
  return SESSIONS_DESIGNER_ENABLED ? children : <SessionsDesignerLockedPage />;
}
